import { formatCurrency, formatDate } from '../fomatter.utils'
import { BODY_FONT, wrapText } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class Tab implements TicketElement {
  code: string
  date: string
  total: string
  lineHeight: number

  constructor(code: string, date: string, total: number) {
    this.code = code
    this.date = formatDate(date)
    this.total = formatCurrency(total)
    this.lineHeight = 25
  }

  height() {
    return this.lineHeight
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number) {
    if (!this.code) return
    top += this.lineHeight
    ctx.fillStyle = 'black'
    ctx.textBaseline = 'bottom'
    ctx.textAlign = 'left'
    ctx.font = `bold 18px ${BODY_FONT}`
    ctx.fillText(this.code, 0, top)
    ctx.font = `16px ${BODY_FONT}`
    ctx.textAlign = 'center'
    ctx.fillText(this.date, width / 2, top)
    const valueWidth = width - (ctx.measureText(this.code).width + 10)
    ctx.textAlign = 'right'
    wrapText(ctx, this.total, width, top, valueWidth)
  }
}
